export default {
  root: '/',
  login: '/login',
  settings: '/settings'
};
